/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyWebhookStatus } from "./CompanyWebhookStatus";
import {
  CompanyWebhookStatusFromJSON,
  CompanyWebhookStatusFromJSONTyped,
  CompanyWebhookStatusToJSON,
  CompanyWebhookStatusToJSONTyped,
} from "./CompanyWebhookStatus";
import type { CompanyWebhookEventType } from "./CompanyWebhookEventType";
import {
  CompanyWebhookEventTypeFromJSON,
  CompanyWebhookEventTypeFromJSONTyped,
  CompanyWebhookEventTypeToJSON,
  CompanyWebhookEventTypeToJSONTyped,
} from "./CompanyWebhookEventType";

/**
 *
 * @export
 * @interface UpdateWebhookRequest
 */
export interface UpdateWebhookRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateWebhookRequest
   */
  webhookUrl: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateWebhookRequest
   */
  subscribeToAllEvents: boolean;
  /**
   *
   * @type {Array<CompanyWebhookEventType>}
   * @memberof UpdateWebhookRequest
   */
  eventTypes?: Array<CompanyWebhookEventType> | null;
  /**
   * Left out by Hubble's edit form: a form opened earlier would otherwise write back a stale status and undo a Reactivate or an automatic pause. Status moves through Reactivate and the pause instead.
   * @type {CompanyWebhookStatus}
   * @memberof UpdateWebhookRequest
   */
  status?: CompanyWebhookStatus | null;
  /**
   *
   * @type {string}
   * @memberof UpdateWebhookRequest
   */
  description?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof UpdateWebhookRequest
   */
  requestHeaders?: { [key: string]: string } | null;
}

/**
 * Check if a given object implements the UpdateWebhookRequest interface.
 */
export function instanceOfUpdateWebhookRequest(
  value: object,
): value is UpdateWebhookRequest {
  if (!("webhookUrl" in value) || value["webhookUrl"] === undefined)
    return false;
  if (
    !("subscribeToAllEvents" in value) ||
    value["subscribeToAllEvents"] === undefined
  )
    return false;
  return true;
}

export function UpdateWebhookRequestFromJSON(json: any): UpdateWebhookRequest {
  return UpdateWebhookRequestFromJSONTyped(json, false);
}

export function UpdateWebhookRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateWebhookRequest {
  if (json == null) {
    return json;
  }
  return {
    webhookUrl: json["webhookUrl"],
    subscribeToAllEvents: json["subscribeToAllEvents"],
    eventTypes:
      json["eventTypes"] == null
        ? undefined
        : (json["eventTypes"] as Array<any>).map(
            CompanyWebhookEventTypeFromJSON,
          ),
    status:
      json["status"] == null
        ? undefined
        : CompanyWebhookStatusFromJSON(json["status"]),
    description: json["description"] == null ? undefined : json["description"],
    requestHeaders:
      json["requestHeaders"] == null ? undefined : json["requestHeaders"],
  };
}

export function UpdateWebhookRequestToJSON(json: any): UpdateWebhookRequest {
  return UpdateWebhookRequestToJSONTyped(json, false);
}

export function UpdateWebhookRequestToJSONTyped(
  value?: UpdateWebhookRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    webhookUrl: value["webhookUrl"],
    subscribeToAllEvents: value["subscribeToAllEvents"],
    eventTypes:
      value["eventTypes"] == null
        ? undefined
        : (value["eventTypes"] as Array<any>).map(
            CompanyWebhookEventTypeToJSON,
          ),
    status: CompanyWebhookStatusToJSON(value["status"]),
    description: value["description"],
    requestHeaders: value["requestHeaders"],
  };
}
